import { useStableValue } from '@whiz-cart/ui-shared/hooks/useStable';
import { urlService } from '@whiz-cart/ui-shared/url/url.service';
import { useMemo } from 'react';

/** Get all specified URL query params */
export function useUrlParams<Keys extends string>(keys: readonly [Keys, ...Keys[]]): Record<Keys, string | undefined> {
    const params = urlService.state.useStore((state) => state.params);
    const stableKeys = useStableValue(keys);
    return useMemo(
        () => Object.fromEntries(stableKeys.map((key) => [key, params[key]])) as Record<Keys, string | undefined>,
        [params, stableKeys],
    );
}
